import { getPlatformConfig } from "@/platform/platform-context";
import type { TimeFrame } from "@/vybe-trader-client/chart/stores/useChartStore";

const VALID_TIMEFRAMES: readonly TimeFrame[] = [
  "1m",
  "5m",
  "15m",
  "30m",
  "1h",
  "2h",
  "4h",
  "12h",
  "1d",
  "1w",
  "1mn",
] as const;

export interface OpenChartPopupOptions {
  symbol: string;
  timeframe: TimeFrame;
}

/** True when running in the dedicated chart-popup window route. */
export function isChartPopupWindow(): boolean {
  return getPlatformConfig().windows.isPopupWindow();
}

function isValidTimeframe(value: string): value is TimeFrame {
  return (VALID_TIMEFRAMES as readonly string[]).includes(value);
}

/** Parse timeframe query param or return null if missing/invalid. */
export function parseChartPopupTimeframe(
  raw: string | null
): TimeFrame | null {
  if (!raw || !isValidTimeframe(raw)) return null;
  return raw;
}

export function openChartPopup({ symbol, timeframe }: OpenChartPopupOptions): void {
  if (!symbol?.trim()) return;

  getPlatformConfig().windows.openChartPopup({
    symbol: symbol.trim(),
    timeframe,
  });
}
